export { default } from '@shikijs/langs/plsql'
